<template>
  <div class="chart-wrapper d-flex flex-column align-items-center justify-content-center">
    <div
      v-if="loading"
      class="chart-donut-canvas skeleton-item skeleton-item-rounded"
      :style="skeletonSize"
    />
    <AppChartDonut
      v-else
      :values="chartData"
      :size="chartSize"
      :inner-radius="chartRadius"
      :sort="false"
      with-tooltips
    >
      <template
        v-if="isReady"
        #text
      >
        <div class="text d-flex flex-column justify-content-center">
          {{ totalIncidents }}
          <span
            v-if="expanded"
            class="label"
          >
            {{ totalIncidentsLabel }}
          </span>
        </div>
      </template>
    </AppChartDonut>
  </div>
</template>

<script>
import { Insights } from '~/mixins';
import { pluralize } from '~/utils/string_utils';
import AppChartDonut from '~/components/AppChartDonut.vue';

// expanded true vs false
const CHART_SIZE = { true: 105, false: 72 };
const CHART_RADIUS = { true: 42, false: 30 };

export default {
  name: 'InsightsUnusualActivityChart',
  components: {
    AppChartDonut,
  },
  mixins: [Insights],
  props: {
    chart: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    totalIncidents: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    totalIncidentsLabel() {
      return pluralize(this.totalIncidents, 'Instance');
    },
    hasChartData() {
      return this.chart && Object.keys(this.chart).length && this.totalIncidents;
    },
    chartData() {
      if (!this.hasChartData) {
        return [{ key: 'empty', value: 100 }];
      }

      return this.data;
    },
    chartSize() {
      return CHART_SIZE[this.expanded];
    },
    chartRadius() {
      return CHART_RADIUS[this.expanded];
    },
    skeletonSize() {
      const pxSize = `${this.chartSize}px`;

      return { width: pxSize, height: pxSize, minWidth: pxSize };
    },
  },
};
</script>
